import { useNavigate } from 'react-router-dom'
import { Application } from '../classes/Application'
import { BriefcaseBusiness } from 'lucide-react'

export default function ApplicationCard({ _application, setApplicationId, setProcessorId }) {
  const navigate = useNavigate()
  const application = new Application(_application)

  return (
    <div
      onClick={() => {
        setApplicationId(application.applicationId);
        setProcessorId(application.processorId);
        navigate(`/applications/${application.applicationId}/dashboard`)
      }}
      key={application.applicationId}
      className='bg-white dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700 p-6 flex flex-col gap-4 hover:shadow-xl hover:border-ertc-primary/30 dark:hover:border-ertc-primary/50 transition-all duration-300 cursor-pointer group'
    >
      <div className='flex items-center gap-4'>
        <div className='w-12 h-12 rounded-xl bg-ertc-primary/10 dark:bg-ertc-primary/20 flex items-center justify-center text-ertc-primary group-hover:bg-ertc-primary group-hover:text-white transition-colors duration-300'>
          <BriefcaseBusiness size={24} />
        </div>
        <div className='flex-1'>
          <p className='font-semibold text-lg text-slate-800 dark:text-gray-100 group-hover:text-ertc-primary transition-colors'>{application.name}</p>
          <p className='text-sm font-medium text-slate-500 dark:text-slate-400'>Claim Amount: <span className='text-emerald-600 dark:text-emerald-400'>${application.claimAmount.toLocaleString()}</span></p>
        </div>
      </div>
    </div>
  )
}